import _isNumber from "lodash/isNumber";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { getCreditScoreBucketValueMax, getCreditScoreBucketValueMin } from '@nerdwallet/nw-client-lib/credit-score';
import Help from '@nerdwallet/react-icon/gizmo/Help';
import Popover from '@nerdwallet/react-popover';
import Type from '@nerdwallet/react-typography';
import styles from '../likelihood-of-approval.module.less';
import { validateApprovalOddsProp, validateRequiredProps } from './prop-types';
export var HEADINGS = {
  APPROVAL_ODDS: 'Your Approval Odds',
  DEFAULT: 'Recommended Credit Score'
};
export var DISCLAIMER_TEXT = 'But, heads up, being within the recommended range doesn’t guarantee approval. Credit score is only one factor lenders consider and they may not use the TransUnion Vantage Score like we do.';
export var getCreditScoreComparisonContent = function getCreditScoreComparisonContent(creditScore, creditScoreBucketValueMax, creditScoreBucketValueMin) {
  var creditScoreComparisonContent = {};

  if (creditScore >= creditScoreBucketValueMax) {
    creditScoreComparisonContent.relativeScoreLabel = 'above the highest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMax;
    creditScoreComparisonContent.pointDifference = creditScore - creditScoreBucketValueMax;
  } else if (creditScore >= creditScoreBucketValueMin) {
    creditScoreComparisonContent.relativeScoreLabel = 'above the lowest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMin;
    creditScoreComparisonContent.pointDifference = creditScore - creditScoreBucketValueMin;
  } else {
    creditScoreComparisonContent.relativeScoreLabel = 'below the lowest';
    creditScoreComparisonContent.scoreToCompare = creditScoreBucketValueMin;
    creditScoreComparisonContent.pointDifference = creditScoreBucketValueMin - creditScore;
  }

  creditScoreComparisonContent.pointDifference = creditScoreComparisonContent.pointDifference === 1 ? '1 point' : "".concat(creditScoreComparisonContent.pointDifference, " points");
  return creditScoreComparisonContent;
};
/**
 * Returns the popover content for the recommended credit score component.
 *
 * @param {number} creditScore
 * @param {number} creditScoreBucketValueMax
 * @param {number} creditScoreBucketValueMin
 * @param {string} disclaimerText
 */

export var recommendedCreditScorePopoverContent = function recommendedCreditScorePopoverContent(creditScore, creditScoreBucketValueMax, creditScoreBucketValueMin) {
  var disclaimerText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DISCLAIMER_TEXT;
  var creditScoreComparisonContent = getCreditScoreComparisonContent(creditScore, creditScoreBucketValueMax, creditScoreBucketValueMin);
  return React.createElement("div", {
    className: styles.popoverContent
  }, React.createElement(Type, {
    className: classes(['padding-top-4', 'padding-bottom-2', 'padding-horizontal-4'])
  }, "You're ", React.createElement("strong", null, creditScoreComparisonContent.pointDifference), " ", creditScoreComparisonContent.relativeScoreLabel, ' ', "suggested score of ", React.createElement("strong", null, creditScoreComparisonContent.scoreToCompare), "."), React.createElement(Type, {
    className: classes(['padding-bottom-4', 'padding-horizontal-4'])
  }, disclaimerText));
};

var Heading = function Heading(_ref) {
  var approvalOdds = _ref.approvalOdds,
      creditScore = _ref.creditScore,
      maxCreditScoreRange = _ref.maxCreditScoreRange,
      minCreditScoreRange = _ref.minCreditScoreRange,
      disclaimerText = _ref.disclaimerText,
      headerComponent = _ref.headerComponent,
      headerText = _ref.headerText,
      id = _ref.id,
      unstyled = _ref.unstyled;
  // Determine heading text/component.
  var heading;

  if (headerComponent) {
    heading = headerComponent;
  } else {
    heading = headerText || (_isNumber(approvalOdds) ? HEADINGS.APPROVAL_ODDS : HEADINGS.DEFAULT);
  } // Conditionally style.


  heading = unstyled ? heading : React.createElement(Type, {
    className: "header-text",
    size: 1,
    bold: true,
    uppercase: true
  }, heading); // Process credit score ranges.

  var creditScoreBucketValueMax = getCreditScoreBucketValueMax(maxCreditScoreRange);
  var creditScoreBucketValueMin = getCreditScoreBucketValueMin(minCreditScoreRange);
  return React.createElement("div", {
    className: classes(['align-items-center', 'display-flex', 'justify-content-space-between', 'justify-content-flex-start--wide'])
  }, heading, !_isNumber(approvalOdds) && !!creditScore && React.createElement(Popover, {
    id: "".concat(id, "__popover"),
    type: ['hover', 'click'],
    popoverContent: recommendedCreditScorePopoverContent(creditScore, creditScoreBucketValueMax, creditScoreBucketValueMin, disclaimerText),
    className: classNames('loa-popover-icon', // for ease of unit testing
    classes(['display-block', 'type-2']))
  }, React.createElement(Help, {
    className: classes(['margin-left-1']),
    textAligned: true
  })));
};

Heading.propTypes = {
  approvalOdds: validateApprovalOddsProp,
  creditScore: PropTypes.number,
  disclaimerText: PropTypes.string,
  headerComponent: PropTypes.element,
  headerText: PropTypes.string,
  id: PropTypes.string.isRequired,
  maxCreditScoreRange: validateRequiredProps,
  // eslint-disable-line react/require-default-props
  minCreditScoreRange: validateRequiredProps,
  // eslint-disable-line react/require-default-props
  unstyled: PropTypes.bool
};
Heading.defaultProps = {
  approvalOdds: undefined,
  creditScore: undefined,
  disclaimerText: DISCLAIMER_TEXT,
  headerComponent: undefined,
  headerText: undefined,
  unstyled: false
};
export default Heading;